import React from 'react';
import { format } from 'utils/formatUtils';

import DataGrid, {
  DataGridBody,
  DataGridCell,
  DataGridRow
} from 'components/DataGrid';

interface MetricsTablelProps {
  metrics: Metrics;
}

const MetricsTable: React.FC<MetricsTablelProps> = ({ metrics }) => {
  return (
    <DataGrid>
      <DataGridBody>
        <DataGridRow>
          <DataGridCell>Number of features</DataGridCell>
          <DataGridCell>{format(metrics.numberOfFeatures)}</DataGridCell>
        </DataGridRow>
        <DataGridRow>
          <DataGridCell>Total size of features</DataGridCell>
          <DataGridCell>
            {format(metrics.totalSizeOfFeaturesBytes)} bytes
          </DataGridCell>
        </DataGridRow>
        <DataGridRow>
          <DataGridCell>Average size of feature</DataGridCell>
          <DataGridCell>
            {format(metrics.averageSizeOfFeaturesBytes)} bytes
          </DataGridCell>
        </DataGridRow>
        <DataGridRow>
          <DataGridCell>Maximum event rate (Standard)</DataGridCell>
          <DataGridCell>
            {format(metrics.maxEventRateInStandard)} features/second
          </DataGridCell>
        </DataGridRow>
        <DataGridRow>
          <DataGridCell>Maximum event rate (Advanced)</DataGridCell>
          <DataGridCell>
            {format(metrics.maxEventRateInAdvanced)} features/second
          </DataGridCell>
        </DataGridRow>
      </DataGridBody>
    </DataGrid>
  );
};

export default MetricsTable;
